import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbHome,
	BreadcrumbItem,
	Button,
	Loading,
	Module,
	ModuleBody,
	SecondaryNavigation,
	SecondaryNavigationTitle,
	Wrapper,
} from '@wfp/ui';
import { lastHomepageUrl } from '../../utils/navigation';
import { useWarning } from '../../hooks/preview';
import { formatDateShort } from '../../utils/utils';

import { WarningEventType, warningEventTypeClass, warningEventTypeLabel } from '../../restapi/types';
import { RiskIcon } from '../common/RiskIcon';
import { SeriousnessDot } from '../common/SeriousnessDot';
import { DocFragment } from '../common/DocFragment';

import './PageTimeline.scss';


export function PageTimeline() {
	const w = useWarning();
	const [showMore, setShowMore] = useState(false);

	return (<div>
		<SecondaryNavigation>
			<Breadcrumb>
				<BreadcrumbItem>
					<Link to="/"><BreadcrumbHome/></Link>
				</BreadcrumbItem>
				<BreadcrumbItem>
					<Link to={lastHomepageUrl}>Homepage</Link>
				</BreadcrumbItem>
				<BreadcrumbItem disableLink>Timeline</BreadcrumbItem>
			</Breadcrumb>
			<SecondaryNavigationTitle>Warning Timeline</SecondaryNavigationTitle>
		</SecondaryNavigation>

		<Wrapper className="no-v-padding" background="lighter" pageWidth="lg" spacing="md">
			{!w ? <Loading withOverlay={false} active small/> : w.events.map(e =>
				<div className="timeline-event">
					<div className="timeline">
						<div className="dot">
							<SeriousnessDot event={e}/>
						</div>
						<div className={'date ' + warningEventTypeClass[e.type]}>
							{formatDateShort(e.date)}
						</div>
					</div>
					<Module>
						<ModuleBody>
							<div className="preview">

								{e.type === WarningEventType.raised ?
									<div className="doc-preview">
										<h2>{w.title}</h2>
										<div>{w.risks.map(
											r => <RiskIcon key={r} risk={r} seriousness={e.seriousness}/>,
										)} {w.description}</div>
										{!showMore ?
											<Button kind="ghost" small
													onClick={() => setShowMore(true)}>
												Show more details...</Button>
											: <>
												<DocFragment title="Key Takeaway"
															 content={w.keyTakeaway}/>
												<DocFragment title="Background"
															 content={w.background}/>
												<DocFragment title="Outlook"
															 content={w.outlook}/>
												<DocFragment title="Indicators to watch"
															 content={w.indicators}/>
												<Button kind="ghost" small
														onClick={() => setShowMore(false)}>
													Show less details...</Button>
											</>
										}
									</div> : <>
										<DocFragment content={e.message || warningEventTypeLabel[e.type]}/>
									</>
								}
							</div>
						</ModuleBody>
					</Module>
				</div>,
			)}
		</Wrapper>
	</div>);
}
